import { startWidget } from "./bootstrap";

startWidget();
